
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'NMID', value: 'nmid', width: '150' },
  { text: 'MID', value: 'mid_bank', width: '200' },
  { text: 'RRN', value: 'rrn', width: '150'},
  { text: 'Metode', value: 'payment_channel', width: '150',},
  { text: 'MPAN', value: 'mpan', width: '150',},
  { text: 'Trx Date', value: 'trx_date', width: '150',},
  { text: 'Trx Time', value: 'trx_time', width: '150',},
  { text: 'Trx Amount ', value: 'amount', width: '150',},
  { text: 'Log Request Payment Credit', value: 'log_request',},
  { text: 'Request By', value: 'maintenance_request_by_name', width: '200',},
  { text: 'Request Date Time', value: 'maintenance_request_date', width: '200',},
  { text: 'Approve By', value: 'maintenance_approve_by_name', width: '200',},
  { text: 'Approve Date', value: 'maintenance_approve_date', width: '200',},
  { text: 'Approval Status', value: 'maintenance_status', width: '200',},
  { text: 'Action', value: 'action', width: '100', align: 'center', },
]);

export const search = {
  nmid: '',
  mid: '',
  mid_bank: '',
  rrn: '',
  payment_channel: '',
  mpan: '',
  trx_date: '',
  trx_time: '',
  maintenance_type: "4"
};

export const editedItem = {
  nmid: '',
  mid: '',
  mid_bank: '',
  rrn: '',
  payment_channel: '',
  mpan: '',
  trx_date: '',
  trx_time: '',
  maintenance_type: "4"
};
